import React from 'react';
import { CircularProgress } from '@material-ui/core';
import GroundLPS from './GroundLPS';
import GroundGPS from './GroundGPS';
import { GroundProps } from '../../types/webPlayer';

const Ground = (props: GroundProps) => {
  const boxRef = React.useRef<HTMLDivElement>(null);

  const {
    currentActivePlayer,
    hoverPlayer,
    defaultPlayersColor,
    fullscreenMode,
    enabledPlayers,
    ground,
    jerseyOrNumber,
    handlePlayerClick,
    handlePlayerEnter,
    handlePlayerLeave,
    infoPlayers,
    isDecodingData,
    isLoadingData,
    loadingPlayers,
    playerLinks,
    playersColors,
    playersDetails,
    handleRemoveLink,
    series,
    showVertices,
    teamColors,
    trailsEnabled,
    userUnits,
  } = props;

  const isGPSGround = ground?.groundCoordsType !== 'LOCAL';
  const loadedPlayersPercentage = 100 - Math.round((enabledPlayers.length - (loadingPlayers.length - 1)) / enabledPlayers.length * 100);

  return (
    <div
      style={{ border: '1px solid #ddd', overflow: 'hidden', position: 'relative' }}
      className="ground-component"
      ref={boxRef}
    >
      {
        loadingPlayers.length > 0
        && (
          <div style={{position: 'absolute', top: 0, left: 0, right: `${loadedPlayersPercentage}%`, height: 5, backgroundColor: 'rgba(255, 255, 255, 0.5)', zIndex: 10, transition: 'right 0.5s ease'}} />
        )
      }

      {
        isLoadingData
        && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 10,
            color: 'white',
          }}
          >
            <CircularProgress color="inherit" size={30} />
          </div>
        )
      }
      {
        ground?.id
        && (
          <div style={isLoadingData ? { opacity: 0.8, pointerEvents: 'none', transition: 'opacity 0.5s' } : {}}>
            {
              isDecodingData
              && (
                <div style={{
                  position: 'absolute',
                  right: 5,
                  bottom: 0,
                  zIndex: 10,
                  color: 'white',
                }}
                >
                  <CircularProgress color="white" size={10} />
                </div>
              )
            }

            {
              !isGPSGround
              && (
                <GroundLPS
                  activePlayer={currentActivePlayer}
                  defaultPlayersColor={defaultPlayersColor}
                  enabledPlayers={enabledPlayers}
                  fullscreenMode={fullscreenMode}
                  groundId={String(ground.id)}
                  hoverPlayer={hoverPlayer}
                  infoPlayers={infoPlayers}
                  jerseyOrNumber={jerseyOrNumber}
                  onPlayerClick={handlePlayerClick}
                  onPlayerEnter={handlePlayerEnter}
                  onPlayerLeave={handlePlayerLeave}
                  playerLinks={playerLinks}
                  playersColors={playersColors}
                  playersDetails={playersDetails}
                  removeLink={handleRemoveLink}
                  series={series}
                  teamColors={teamColors}
                  trailsEnabled={trailsEnabled}
                  userUnits={userUnits}
                />
              )
            }

            {
              isGPSGround && (
                <GroundGPS
                  activePlayer={currentActivePlayer}
                  defaultPlayersColor={defaultPlayersColor}
                  fullscreenMode={fullscreenMode}
                  enabledPlayers={enabledPlayers}
                  groundId={String(ground.id)}
                  hoverPlayer={hoverPlayer}
                  infoPlayers={infoPlayers}
                  jerseyOrNumber={jerseyOrNumber}
                  onPlayerClick={handlePlayerClick}
                  onPlayerEnter={handlePlayerEnter}
                  onPlayerLeave={handlePlayerLeave}
                  playerLinks={playerLinks}
                  playersColors={playersColors}
                  playersDetails={playersDetails}
                  removeLink={handleRemoveLink}
                  series={series}
                  showVertices={showVertices}
                  teamColors={teamColors}
                  trailsEnabled={trailsEnabled}
                  userUnits={userUnits}
                />
              )
            }
          </div>
        )
      }
    </div>
  );
};

export default Ground;
